import { css } from '@emotion/react';

export const formSide = css`
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  padding: 0px 127px 53px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;

  @media only screen and (max-width: 1024px) {
    padding: 221px 64px 53px;
  }

  @media only screen and (max-width: 768px) {
    padding: 132px 28px 24px;
  }
`;

export const formContainer = css`
  max-width: 358px;

  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    max-width: 600px;
  }
`;

export const coloredLogoLink = css`
  position: absolute;
  top: 24px;
  left: 28px;
`;

export const customLogo = css`
  min-height: 25px;
  max-height: 27px;

  max-width: 200px;
`;
